import { CATEGORY_TEXT_ROLES } from "./tmConstants";

/**
 * A blank per-role text style entry — every property null except role.
 * `font_file` is a transient (frontend-only) field: a pending File the
 * user picked for this role's font, not yet uploaded. It never reaches
 * the API directly — see buildTextStylesFormData.
 */
export const blankTextStyle = (role) => ({
  role,
  font_name: null,
  font_url: null,
  font_file: null,
  font_size: null,
  color: null,
  align: null,
  weight: null,
  tracking: null,
  opacity: null,
  format: null,
  text: null,
});

/** The default set of text style entries for a given widget category. */
export const defaultTextStylesFor = (category) =>
  (CATEGORY_TEXT_ROLES[category] || []).map((role) => blankTextStyle(role));

/**
 * Append a variant's text_styles to a FormData submission: the JSON
 * array (minus the transient `font_file`) under `text_styles`, plus
 * one `text_style_font__<role>` file field per role with a pending
 * font upload.
 */
export const buildTextStylesFormData = (fd, list = []) => {
  const clean = list.map(({ font_file, ...rest }) => rest);
  fd.append("text_styles", JSON.stringify(clean));
  for (const entry of list) {
    if (entry.font_file instanceof File) {
      fd.append(`text_style_font__${entry.role}`, entry.font_file);
    }
  }
};
